define('subMenu', [], function () {
    const subMenu = {};
    subMenu.isInit = false;
    subMenu.chatsUnread = 0;
    subMenu.notificationsUnread = 0;
    subMenu.init = function () {
        if (subMenu.isInit) return;
        const $subNav = $('#panel #header-sub-menu'),
            $subMenu = $subNav.find('.container'),
            $menuRight = $subMenu.find('.sub-navbar-right');

        const $searchItem = $menuRight.find('.search-item'),
            $searchDown = $menuRight.find('.search-down'),
            $searchMod = $searchDown.find('.search-mod'),
            $searchForm = $searchMod,
            $searchInput = $searchMod.find('.search-mod-input');

        const $userLabel = $menuRight.find('#user_label'),
            $userDot = $userLabel.find('.dropdown-toggle .icon-icon_person-2');

        subMenu.notificationsUnread = +$userLabel.find('#user-control-list [component="notifications"] [component="notifications/icon"]').attr('data-content');
        subMenu.chatsUnread = +$userLabel.find('#user-control-list .chats [component="chat/icon"]').attr('data-content');

        socket.on('event:unread.updateChatCount', function (count) {
            subMenu.chatsUnread = count;
            handleDot();
        });
        $(window).on('action:notification.updateCount', (_, { count }) => {
            subMenu.notificationsUnread = count;
            handleDot();
        });
        $searchDown.on('click', function (event) {
            event.stopPropagation();
        });
        $searchItem.on('click', () => {
            if ($searchMod.hasClass('hidden')) {
                $searchMod.removeClass('hidden');
                $searchInput.trigger('focus');
                $subNav.on('mouseleave', hidden);
            }

            function hidden() {
                $searchMod.addClass('hidden');
                $subNav.off('mouseleave', hidden);
            }
        });

        handleSearch();
        subMenu.isInit = true;

        function handleDot() {
            if ($userDot.hasClass('unread-dot')) {
                if (0 === subMenu.chatsUnread && 0 === subMenu.notificationsUnread) {
                    $userDot.removeClass('unread-dot');
                }
            } else if (0 !== subMenu.chatsUnread || 0 !== subMenu.notificationsUnread) {
                $userDot.addClass('unread-dot');
            }
        }

        function handleSearch(searchOptions) {
            if (!config.searchEnabled) {
                return;
            }
            searchOptions = searchOptions || { in: 'titles' };
            const quickSearchContainer = $searchDown.find('#quick-search-container');

            $searchInput.off('focus');

            const searchElements = {
                inputEl: $searchInput,
                resultEl: quickSearchContainer,
            };

            app.enableTopicSearch({
                searchOptions: searchOptions,
                searchElements: searchElements,
            });

            $searchForm.off('submit').on('submit', function () {
                require(['search'], function (search) {
                    const data = search.getSearchPreferences();
                    data.term = $searchInput.val();
                    $(window).trigger('action:search.submit', {
                        searchOptions: data,
                        searchElements: searchElements,
                    });
                    search.query(data, function () {
                        $searchInput.val('');
                    });
                });
                return false;
            });
        }
    };
    return subMenu;
});
